import React, { Component } from "react";
import Header from "../common/Header";
import Sidebar from "./Sidebar";

import { Link } from "react-router-dom";

import NumberFormat from "react-number-format";

import axios from "axios";
import swal from "sweetalert";
import $ from "jquery";

export class UserDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage["appState"]
        ? JSON.parse(localStorage["appState"]).user.token
        : "",
      user: [],
      user_referrals: [],
      user_earnings: [],
      total_earnings: ""
    };
  }

  componentDidMount() {
    this.getUser();
  }

  getUser() {
    let id = window.location.href.split("/")[
      window.location.href.split("/").length - 1
    ];

    axios
      .get(`${axios.defaults.baseURL}/user/${id}`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({ user: json.data.user[0], 
            user_referrals: json.data.user_referrals,
            user_earnings: json.data.user_earnings,
            total_earnings: json.data.total_earnings, });
          // } else alert("Cannot Fetch Data!");
        } else swal("Oops!", "Cannot Fetch Data!", "error");
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
    // alert(id)
  }

  makeAdmin(id) {

    axios({
        method: 'get',
        url: `${axios.defaults.baseURL}/make-admin/${id}`
        })
      .then((response) => {
        //console.log(response);
        return response;
      })
  };

  donePayment(id) {

    axios({
        method: 'get',
        url: `${axios.defaults.baseURL}/done-ref-payment/${id}`
        })
      .then((response) => {
        //console.log(response);
        return response;
      });
      this.getUser();
  };

  render() {
    return (
      <div id="app" className="bg-gray-200">
        <div className="dashboard-page">
          <div className="private-layout">
            <div className="app-wrapper">
              <Sidebar />
              <Header />
              <div id="main-app" className="position-relative">
                <div className="container mt-4">
                  <div className="page-title">
                    <div className="row text-primary py-2 pt-4">
                      <div className="col-10">
                        <div
                          className="user-welcome"
                          style={{ overflow: "hidden" }}
                        >
                          <Link to="/admin/users-list">
                            <i className="ti-arrow-left"></i> Back to Users List
                          </Link>
                          <div className="wrapper d-flex mt-2">
                            <h4 className="d-inline-block">
                              View User
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="text-right col-2"></div>
                    </div>
                  </div>

                  <div>
                    <div
                      data-v-22924209=""
                      class="dash-card-plan bg-white mb-4"
                    >
                      <div className="row">
                        <div className="col-md-4 text-center">
                            <img src={this.state.user.image} className="user-img p-2" alt="" />
                            <br/>
                            <br/>
                            {this.state.user.type == 1 ? (
                              <Link onClick={this.makeAdmin.bind(this, this.state.user.id)} className="btn mr-2 btn-warning">
                                  Make User Admin
                              </Link>
                            ) : null
                            }
                        </div>
                        <div className="col-md-8">
                          <div className="p-4">
                          <div className="">
                                  <h5 className="mb-0">Personal Details</h5>
                                </div>
                            <br />
                            <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1 titlecase">
                                  <b>Firstname: {this.state.user.fname}</b>
                                </p>
                              </div>
                              <div className="col">
                                <p className="mb-1 titlecase">
                                    <b>Lastname: {this.state.user.lname}</b>
                                    </p>
                              </div>
                            </div>
                            <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1 titlecase">
                                  <b>Residential Address: {this.state.user.address}</b>
                                </p>
                              </div>
                            </div>
                            <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1">
                                  <b>Email: {this.state.user.email}</b>
                                </p>
                              </div>
                              <div className="col">
                                <p className="mb-1 titlecase">
                                    <b>Telephone: {this.state.user.phone}</b>
                                    </p>
                              </div>
                            </div>
                            <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1">
                                  <b>Date of Birth: {this.state.user.dob}</b>
                                </p>
                              </div>
                              <div className="col">
                                <p className="mb-1 titlecase">
                                    <b>Marital Status: {this.state.user.mstatus}</b>
                                    </p>
                              </div>
                            </div>
                            <br/>
                            <div className="">
                                  <h5 className="mb-4">Next of Kin</h5>
                                </div>
                                <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1 titlecase">
                                  <b>Fullname: {this.state.user.kfullname}</b>
                                </p>
                              </div>
                            </div>
                            <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1 titlecase">
                                  <b>Address: {this.state.user.kaddress}</b>
                                </p>
                              </div>
                            </div>
                            <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1">
                                  <b>Email: {this.state.user.kemail}</b>
                                </p>
                              </div>
                              <div className="col">
                                <p className="mb-1 titlecase">
                                    <b>Telephone: {this.state.user.kphone}</b>
                                    </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='container'>
                <table class="mt-4 table">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">User Earnings</th>
                      </tr>
                    </thead>
                  </table>
                  {this.state.isLoading ? (
                    <div
                      data-v-22924209=""
                      class="dash-card-plan bg-white"
                    >
                      <div className="dash-card-main bg-cover blink_me text-center">
                        <br />
                        Loading...
                        <br />
                        <br />
                      </div>
                    </div>
                  ) : (
                    <>
                      {this.state.user_earnings != "" ? (
                        <div className="align-items-stretch">
                          <table class="table">
                            <tbody>
                              {this.state.user_earnings.map((earning, index) => (
                                <tr>
                                  <td>{earning.date}</td>
                                  <td><NumberFormat value={earning.commission} displayType={'text'} thousandSeparator={true} prefix={'₦'} /> </td>
                                  
                                  {earning.status == 1 ?
                                  <td>Paid</td>
                                  : earning.status == 2 ? (
                                  <>
                                    <td>Payment Requested</td>
                                    <td>
                                        <button
                                        className="text-primary"
                                        style={{background:"none", border:"none"}}
                                        onClick={this.donePayment.bind(this, earning.id)}
                                        >
                                            Payment Done
                                        </button>
                                    </td>
                                  </>
                                  ): null}
                                </tr>
                              ))}
                              <tr>
                                  <td><b>Total Earnings</b></td>
                                  <td><NumberFormat value={this.state.total_earnings} displayType={'text'} thousandSeparator={true} prefix={'₦'} /> </td>
                                </tr>
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div
                          data-v-22924209=""
                          class="empty-placeholder dash-card bg-white"
                        >
                          User has no earnings yet.
                        </div>
                      )}
                    </>
                  )}
                  <table class="mt-4 table">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">User Referrals</th>
                      </tr>
                    </thead>
                  </table>
                  {this.state.isLoading ? (
                    <div
                      data-v-22924209=""
                      class="dash-card-plan bg-white"
                    >
                      <div className="dash-card-main bg-cover blink_me text-center">
                        <br />
                        Loading...
                        <br />
                        <br />
                      </div>
                    </div>
                  ) : (
                    <>
                      {this.state.user_referrals != "" ? (
                        <div className="align-items-stretch">
                          <table class="table">
                            <tbody>
                              {this.state.user_referrals.map((user, index) => (
                                <tr>
                                  <td>{index+1}</td>
                                  <td>{user.fname}</td>
                                  <td>{user.lname}</td>
                                  <td>{user.email}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div
                          data-v-22924209=""
                          class="empty-placeholder dash-card bg-white"
                        >
                          User has no referrals yet.
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UserDetails;
